import { ShippingMethod } from 'types/entity/cart';
import { Order } from 'types/entity/order';
import ThankYouFooter from './components/ThankYouFooter';
import ThankYouHeader from './components/ThankYouHeader';
import ThankYouOrderInfo from './components/ThankYouOrderInfo';
import ThankyoupageOrderSummary from './components/ThankyoupageOrderSummary';

type ThankYouProps = {
  order: Order;
  shippingMethods: ShippingMethod[];
  orderNumberPending?: boolean;
};

const ThankYouContent: React.FC<ThankYouProps> = ({ order, shippingMethods, orderNumberPending }) => {
  return (
    <div className="bg-neutral-200 lg:gap-[26px] lg:p-[50px]">
      <div className="flex flex-col lg:flex-row lg:items-start lg:gap-[26px] lg:px-5 lg:py-12 xl:px-12">
        <div className="bg-white px-4 md:px-6 lg:w-[65%] lg:rounded-md lg:py-9">
          <ThankYouHeader email={order?.email || order?.shippingAddress?.email} loading={!order} />
          <ThankYouOrderInfo
            shipToName={
              order?.custom?.fields?.shippyProPickupPointId
                ? (order.custom.fields.shippyProPickupPointName ?? '')
                : `${order?.shippingAddress?.firstName ?? ''} ${order?.shippingAddress?.lastName ?? ''}`.trim()
            }
            order={order}
            shippingMethods={shippingMethods}
            orderNumberPending={orderNumberPending}
          />
          <ThankYouFooter loading={!order?.sum} />
        </div>

        <ThankyoupageOrderSummary order={order} />
      </div>
    </div>
  );
};

export default ThankYouContent;
